import { User } from './models';
import { AppRole } from './roles';

export const isSuperUser = (user: User): boolean => {
  return user.appRoles.includes(AppRole.SUPER_USER) || false;
};
